var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#A0D7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5838 13.4581H14.333",
    stroke: "#2D9CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.959 15.0841V11.8333",
    stroke: "#2D9CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0977 20.5195H13.0811",
    stroke: "#2D9CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2576 8.2915C19.2576 8.2915 12.8601 8.29484 12.8501 8.29484C10.5501 8.309 9.12598 9.82234 9.12598 12.1307V19.794C9.12598 22.114 10.561 23.6332 12.881 23.6332C12.881 23.6332 19.2776 23.6307 19.2885 23.6307C21.5885 23.6165 23.0135 22.1023 23.0135 19.794V12.1307C23.0135 9.81067 21.5776 8.2915 19.2576 8.2915Z",
    stroke: "#2D9CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0967 17.25H13.0801",
    stroke: "#2D9CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialist);
export default __webpack_public_path__ + "static/media/specialist.5e41c258dda431313af7ecbb7802c4db.svg";
export { ForwardRef as ReactComponent };